import { render } from "./main.vue?vue&type=template&id=39b37181&scoped=true&lang=pug"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=39b37181&lang=scss"
import "./main.vue?vue&type=style&index=1&id=39b37181&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b37181"]])

export default __exports__